import React from 'react';

const Project = ({ name, coverImage, description, technologies, status, links }) => {
  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition duration-300">
      <img src={coverImage} alt={name} className="w-full aspect-square object-cover" />
      <div className="p-6">
        <div className="flex justify-between items-start mb-2">
          <h3 className="text-xl font-semibold text-dark">{name}</h3>
          <span className={`px-2 py-1 rounded text-xs font-medium ${
            status === 'Active Development' ? 'bg-yellow-100 text-yellow-800' :
            status === 'Beta Release' ? 'bg-blue-100 text-blue-800' :
            'bg-green-100 text-green-800'
          }`}>
            {status}
          </span>
        </div>
        <p className="text-secondary mb-4">{description}</p>
        <div className="mb-4">
          <h4 className="text-sm font-semibold text-dark mb-2">Technologies:</h4>
          <div className="flex flex-wrap gap-2">
            {technologies.map((tech, index) => (
              <span key={index} className="bg-gray-100 text-secondary px-2 py-1 rounded text-xs">
                {tech}
              </span>
            ))}
          </div>
        </div>
        <div className="flex space-x-4">
          {links.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:text-secondary font-medium text-sm"
            >
              {link.label} →
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Project;